import styled from '@emotion/styled';

import breakPoints from 'app/styles/constants/breakpoints';

const { widthSmall, widthMedium } = breakPoints;
const S = {};

S.PerksWrapper = styled.div`
  label: PerksWrapper;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 2.1875rem;
  row-gap: 2.375rem;
  max-width: 23.5rem;
  padding: 0 1.25rem;

  @media (${widthSmall}) {
    column-gap: 5rem;
    row-gap: 3.5rem;
    max-width: 37.5rem;

    padding: 0 2.5rem;
  }

  @media (${widthMedium}) {
    grid-template-columns: repeat(4, 1fr);
    max-width: 75rem;
  }
`;

S.Perk = styled.div`
  label: Perk;

  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--colors-white);
`;

S.PerkIcon = styled.svg`
  label: PerkIcon;

  width: 1.875rem;
  margin-bottom: 1rem;
  fill: currentColor;

  @media (${widthSmall}) {
    width: 2.5rem;
  }
`;

export default S;
